(function () {
  const SELECTOR = '[data-canicule-popularity]';

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function renderBadges(container, badges) {
    const list = container.querySelector('[data-canicule-popularity-badges]');
    if (!list || !badges || !badges.length) return;

    list.innerHTML = badges.map(function (badge) {
      const type = badge.type || 'factual';
      const detail = badge.detail ? ' title="' + escapeHtml(badge.detail) + '"' : '';
      return '<span class="canicule-popularity__badge canicule-popularity__badge--' + type + '" role="listitem"' + detail + '>' +
        escapeHtml(badge.label) + '</span>';
    }).join('');
  }

  function renderProofs(container, proofs, meta) {
    const wrap = container.querySelector('[data-canicule-popularity-proofs]');
    if (!wrap || !proofs || !proofs.length) return;

    const prefix = meta && meta.attributionPrefix ? meta.attributionPrefix : 'Donnée marketplace · hors Canicule';

    wrap.innerHTML = proofs.map(function (proof) {
      const text = proof.formulation || proof.metric || '';
      const link = proof.url
        ? ' <a class="canicule-popularity__proof-link" href="' + escapeHtml(proof.url) + '" target="_blank" rel="noopener noreferrer">Source ' + escapeHtml(proof.platform || '') + '</a>'
        : '';
      return '<p class="canicule-popularity__proof">' + escapeHtml(text) + link + '</p>';
    }).join('') + '<p class="canicule-popularity__proof-note">' + escapeHtml(prefix) + '</p>';

    wrap.hidden = false;
  }

  function initContainer(container, data) {
    const handle = container.dataset.productHandle;
    const productData = data[handle];
    if (!productData) return;

    renderBadges(container, productData.badges);
    if (container.classList.contains('canicule-popularity--pdp')) {
      renderProofs(container, productData.proofs, data.meta);
    }
    container.hidden = false;
  }

  function initAll(scope) {
    const containers = scope.querySelectorAll(SELECTOR);
    if (!containers.length) return;

    const url = containers[0].dataset.popularityUrl;
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return;
        containers.forEach(function (container) {
          initContainer(container, data);
        });
      })
      .catch(function () { /* silent */ });
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
